import { useForm, SubmitHandler } from 'react-hook-form'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

import { ForgotPasswordModel } from 'utils/models/Auth'
import { CustomTextField } from 'components/CustomTextField'
import { getOrganisationId } from 'utils/organisation'
import { BASEURL } from 'utils/constants/clientRoutes'
import { useResetPasswordRequest } from 'utils/auth'
import { useState } from 'react'
import AuthPageWrapper from './AuthPageWrapper'
import { toast } from 'react-toastify'

const validationSchema = Yup.object<ForgotPasswordModel>().shape({
  email: Yup.string()
    .email('Email address format is incorrect')
    .required('Email is required'),
})

const ResendLink = () => {
  const { mutateAsync } = useResetPasswordRequest()
  const [sendMail, setSendMail] = useState(false)

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<ForgotPasswordModel>({
    resolver: yupResolver(validationSchema),
  })

  const onSubmit: SubmitHandler<ForgotPasswordModel> = async data => {
    const forgotPasswordData = {
      userEmail: data.email,
      baseSiteUrl: BASEURL,
      organisationId: getOrganisationId(),
    }
    try {
      await mutateAsync(forgotPasswordData)
      setSendMail(true)
    } catch (_) {
      toast.error('Failed to send a link, please try again shortly.')
    }
  }

  return (
    <AuthPageWrapper
      title="Finish your account setup"
      description="To complete your account setup, please enter your email below. We’ll send you a link to finish the process safely."
      showPanel={false}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <CustomTextField
          control={control}
          errors={errors?.email}
          name="email"
          label="Email"
        />

        <div className="w-full my-auto mx-0 mt-8">
          <button
            type="submit"
            className="w-full py-4 button bg-branding-secondary"
          >
            {isSubmitting && (
              <span className="spinner-border spinner-border-sm mr-1"></span>
            )}
            Send Setup Link
          </button>
        </div>
        {sendMail && (
          <p className="mt-9 font-normal text-main text-branding-secondary">
            If the email address is registered, we’ve sent a link. Please click
            on the link to finish setting up your account.
          </p>
        )}
      </form>
    </AuthPageWrapper>
  )
}

export default ResendLink
